import { useUnit } from 'effector-react'
import type React from 'react'

import {
    SignupStepEmail,
    SignupStepPassword,
    StepAccountAlreadyExists,
    StepEmailMaybeUndeliverable,
    StepPasswordTooSimple,
    StepSignupFailed,
} from './signup'
import * as steps from './steps'

const stepMap: Record<steps.Step, () => React.ReactNode> = {
    login: () => null,
    signup_email: () => <SignupStepEmail />,
    signup_password: () => <SignupStepPassword />,
    email_maybe_undeliverable: () => <StepEmailMaybeUndeliverable />,
    account_already_exists: () => <StepAccountAlreadyExists />,
    signup_error_password_too_simple: () => <StepPasswordTooSimple />,
    signup_failed: () => <StepSignupFailed />,
}

export function SignupCardBody() {
    const currentStep = useUnit(steps.$currentStep)

    return stepMap[currentStep]()
}
